import { CheckCircle2, CircleDashed, Clock } from "lucide-react";
import { api, safe } from "@/lib/api";
import { toast } from "sonner";

const ICON = { Received: [CheckCircle2, "text-emerald-600"], Missing: [CircleDashed, "text-slate-400"], Expired: [Clock, "text-amber-600"] };

export function KycChecklist({ c, onCase }) {
  const locked = !!c.signoff;
  const set = safe(async (key, status) => {
    const { data } = await api.put(`/kyc/cases/${c.id}/checklist/${key}`, { status });
    onCase(data);
    toast.success(`Document marked ${status.toLowerCase()}`);
  });
  return (
    <div className="panel overflow-hidden" data-testid="kyc-checklist">
      <div className="px-5 py-3.5 border-b border-slate-100 flex justify-between">
        <span className="text-sm font-semibold text-slate-900">Document checklist</span>
        <span className="num text-[11px] text-slate-500" data-testid="kyc-docs-progress">{c.progress.docs_received}/{c.progress.docs_required} required received</span>
      </div>
      <div className="divide-y divide-slate-100">
        {c.checklist.map((i) => {
          const [Icon, col] = ICON[i.status];
          return (
            <div key={i.key} data-testid={`kyc-doc-${i.key}`} className="px-5 py-2.5 flex flex-wrap items-center gap-3">
              <Icon className={`w-4 h-4 shrink-0 ${col}`} />
              <div className="flex-1 min-w-[200px]">
                <div className="text-xs text-slate-900">{i.label}{!i.required && <span className="text-slate-400"> · optional</span>}</div>
                {i.updated_by && <div className="text-[10px] text-slate-400">Updated by {i.updated_by}</div>}
              </div>
              <span data-testid={`kyc-doc-status-${i.key}`} className={`text-[11px] font-medium ${col}`}>{i.status}</span>
              {!locked && (
                <div className="flex gap-1">
                  {["Received", "Missing", "Expired"].filter((s) => s !== i.status).map((s) => (
                    <button key={s} data-testid={`kyc-doc-set-${i.key}-${s.toLowerCase()}`} onClick={() => set(i.key, s)} className="text-[10px] px-2 py-1 rounded-md border border-slate-200 text-slate-600 hover:border-sky-300 hover:text-sky-700 transition-colors">{s}</button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
